import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { toast } from '../components/ui/sonner';

function formatApiError(error) {
  return error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Unable to update account.';
}

export default function MyAccountPage() {
  const { user, updateProfile } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setName(user?.name || '');
    setEmail(user?.email || '');
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await updateProfile(name, email);
      toast.success('Account updated');
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-5 animate-fade-in" data-testid="my-account-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#1C1B1A]" style={{ fontFamily: 'Manrope, sans-serif' }}>My Account</h1>
        <p className="text-[#5C5A56] text-sm mt-1">Manage your profile details from the top-right account menu.</p>
      </div>

      <Card className="border-[#E8E6E1] shadow-sm rounded-2xl">
        <CardHeader>
          <CardTitle className="text-[#1C1B1A]">Profile Details</CardTitle>
          <CardDescription>These details are used across the app shell and account menus.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="space-y-2">
                <Label htmlFor="account-name">Full Name</Label>
                <Input id="account-name" name="name" value={name} onChange={(e) => setName(e.target.value)} className="border-[#E8E6E1]" required />
              </div>
              <div className="space-y-2">
                <Label htmlFor="account-email">Email Address</Label>
                <Input id="account-email" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="border-[#E8E6E1]" required />
              </div>
            </div>
            <div className="flex justify-end">
              <Button type="submit" className="bg-[#1E3F2D] hover:bg-[#29563E] text-white rounded-xl" disabled={saving}>
                {saving ? 'Saving...' : 'Save Changes'}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
